import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { EventCard } from "@/components/Cards";
import { TID } from "@/constants/testIds";
import { Search } from "lucide-react";

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "music", label: "Music" },
  { key: "festivals", label: "Festivals" },
  { key: "food-drink", label: "Food & Drink" },
  { key: "family", label: "Family" },
  { key: "sports", label: "Sports" },
  { key: "wellness", label: "Wellness" },
  { key: "networking", label: "Networking" },
];

export default function Events() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState(params.get("q") || "");
  const [cat, setCat] = useState(params.get("cat") || "all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/events", { params: { category: cat, q: q || undefined } })
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, [cat, q]);

  const onSearch = (e) => {
    e.preventDefault();
    const nq = e.target.q.value;
    setQ(nq);
    setParams({ q: nq, cat });
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-24">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <span className="editorial-divider" />
        <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Events.</h1>
        <p className="text-lg text-[color:var(--forest-2)] mt-4 max-w-2xl">
          From beachfront festivals to sunset sessions — the pulse of the Gold Coast.
        </p>
      </motion.div>

      <form onSubmit={onSearch} className="mt-10 flex items-center gap-2 bg-white border border-[color:var(--forest-line)] rounded-full pl-5 py-2 pr-2 max-w-xl">
        <Search size={16} className="opacity-60" />
        <input
          name="q"
          defaultValue={q}
          data-testid={TID.eventSearchInput}
          placeholder="Search events, artists, venues…"
          className="flex-1 bg-transparent outline-none py-2 text-sm"
        />
        <button className="btn-pill btn-primary text-sm">Search</button>
      </form>

      <div className="mt-8 flex flex-wrap gap-2">
        {CATEGORIES.map((c) => (
          <button
            key={c.key}
            onClick={() => { setCat(c.key); setParams({ cat: c.key, ...(q && { q }) }); }}
            data-testid={TID.eventCategoryFilter(c.key)}
            className={`chip ${cat === c.key ? "chip-active" : ""}`}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((e, i) => <EventCard key={e.id} event={e} index={i} />)}
      </div>
      {!loading && items.length === 0 && (
        <div className="py-24 text-center text-[color:var(--forest-2)]">No events match your search.</div>
      )}
    </div>
  );
}
